document.addEventListener('DOMContentLoaded', k_event_carousel);

function k_event_carousel() {
  const wrapper = document.querySelector('.event-carousel');
  if (!wrapper || typeof gsap === 'undefined') return;

  const track = wrapper.querySelector('.event-carousel__track');
  const slides = Array.from(track.children);
  if (slides.length < 2) return;

  // Clone the last slide before the first, and the first slide after the
  // last, so the loop can wrap seamlessly in either direction without ever
  // animating backwards through the whole track.
  const cloneOfLast = slides[slides.length - 1].cloneNode(true);
  const cloneOfFirst = slides[0].cloneNode(true);
  track.insertBefore(cloneOfLast, track.firstChild);
  track.appendChild(cloneOfFirst);

  const realCount = slides.length;
  const totalSlots = realCount + 2;
  const DRAG_DEADZONE = 5; // px of movement before a press counts as a drag, not a click
  const COMMIT_RATIO = 0.2; // fraction of the slide width needed to commit to the next/prev slide
  const AUTOPLAY_DELAY = 4000; // ms between automatic slides
  const AUTOPLAY_PAUSE = 6000; // ms to wait after an interaction before autoplay resumes

  let index = 0; // logical index into the real slides (0..realCount-1)
  let animating = false;
  let pointerDown = false;
  let dragging = false;
  let pointerDownX = 0;
  let baseX = 0;

  const slideWidth = () => wrapper.getBoundingClientRect().width;
  const slotOf = (i) => i + 1; // real slide i lives in track slot i+1 (slot 0 is the leading clone)
  const positionOf = (slot) => -slot * slideWidth();

  gsap.set(track, {x: positionOf(slotOf(index))});

  function goToSlot(slot, fast = false) {
    animating = true;
    gsap.to(track, {
      x: positionOf(slot),
      duration: fast ? 0.4 : 0.7,
      ease: fast ? 'power2.out' : 'power3.inOut',
      onComplete() {
        if (slot === totalSlots - 1) {
          // Landed on the trailing clone of the first slide — snap back to the real one.
          index = 0;
          gsap.set(track, {x: positionOf(slotOf(0))});
        } else if (slot === 0) {
          // Landed on the leading clone of the last slide — snap back to the real one.
          index = realCount - 1;
          gsap.set(track, {x: positionOf(slotOf(realCount - 1))});
        } else {
          index = slot - 1;
        }
        animating = false;
      },
    });
  }

  function next() {
    if (animating || dragging) return;
    goToSlot(slotOf(index) + 1);
  }

  let autoplayTimer = null;
  let autoplayResumeTimer = null;

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(next, AUTOPLAY_DELAY);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function onInteraction() {
    stopAutoplay();
    clearTimeout(autoplayResumeTimer);
    autoplayResumeTimer = setTimeout(startAutoplay, AUTOPLAY_PAUSE);
  }

  wrapper.querySelectorAll('.event-carousel__next').forEach((btn) => {
    btn.addEventListener('click', next);
  });

  wrapper.addEventListener('pointerdown', (e) => {
    onInteraction();
    if (animating) return;
    pointerDown = true;
    dragging = false;
    pointerDownX = e.clientX;
    baseX = positionOf(slotOf(index));
  });

  wrapper.addEventListener('pointermove', (e) => {
    if (!pointerDown) return;

    const totalDelta = e.clientX - pointerDownX;

    if (!dragging) {
      if (Math.abs(totalDelta) < DRAG_DEADZONE) return;
      dragging = true;
      gsap.killTweensOf(track);
      wrapper.style.cursor = 'grabbing';
    }

    // Stop ScrollSmoother (smoothTouch is enabled globally) and the browser's
    // own touch-scroll from also reacting to this same horizontal drag.
    e.preventDefault();
    e.stopPropagation();

    const min = positionOf(totalSlots - 1);
    const max = positionOf(0);
    const x = Math.min(Math.max(baseX + totalDelta, min), max);
    gsap.set(track, {x});
  });

  function endDrag() {
    if (!pointerDown) return;
    pointerDown = false;
    wrapper.style.cursor = '';
    onInteraction();
    if (!dragging) return; // plain click — the arrow's own click handler deals with it
    dragging = false;

    const currentX = gsap.getProperty(track, 'x');
    const delta = currentX - baseX;
    const threshold = slideWidth() * COMMIT_RATIO;
    const currentSlot = slotOf(index);

    if (delta < -threshold) {
      goToSlot(currentSlot + 1, true);
    } else if (delta > threshold) {
      goToSlot(currentSlot - 1, true);
    } else {
      goToSlot(currentSlot, true);
    }
  }

  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);

  window.addEventListener('resize', () => {
    if (!animating && !dragging) gsap.set(track, {x: positionOf(slotOf(index))});
  });

  startAutoplay();
}
